import styled from 'styled-components';

export const DropdownHeader = styled.strong`
  padding: var(--spacing-02) var(--spacing-05);
  padding-top: 0;
  margin-bottom: var(--spacing-03);
  display: flex;
  pointer-events: none;
`;
